<template>
  <div class="edit">
    <h1>Schuifwand options</h1>

    <form class="default-form edit-form" @submit.prevent="">

      <div class="default-form-field">

        <div class="default-form-field-options row" style="flex-direction: row; text-align: left;">
          <span class="item row-header">keyName</span>
          <span class="item row-header">label</span>
          <span class="item row-header">afbeelding</span>
          <span class="item row-header">infobox</span>
          <span class="item row-header">standaard aan</span>
          <span class="item row-header"></span>

          <div v-for="(option, i) in schuifwandOptions" :key="i" class="default-form-field-options-edit-row row">
            <div class="item">
              <select v-model="option.keyName" class="default-form-field-input" style="width: 100%">
                <option v-for="(keyname, j) in filteredSchuifwandOptionsKeyNames(i)" :key="'diff'+i+'-'+j" :value="keyname">{{keyname}}</option>
              </select>
            </div>

            <div class="item">
              <input type="text" class="default-form-field-input" :id="'input' + i" v-model.trim="option.label" @keydown.enter="add(i + 1)">
            </div>

            <div class="item">
              <select v-model="option.uiImage" class="default-form-field-input" style="width: 100%">
                <option v-for="(texture, j) in texturesWithEmpty" :key="'diff'+i+'-'+j" :value="texture.id">{{texture.name}}</option>
              </select>
            </div>

            <div class="item">
              <select v-model="option.infobox" class="default-form-field-input" style="width: 100%">
                <option v-for="(infobox, j) in infoboxesWithEmpty" :key="'diff'+i+'-'+j" :value="infobox.id">{{infobox.name}}</option>
              </select>
            </div>

            <div class="item">
              <input class="checkbox" type="checkbox" :id="`defaultOn`+i" name="defaultOn-checkbox" v-model="option.defaultOn">
              <label :for="`defaultOn`+i" class="checkbox-label sizes-form-checkbox" style="float: none; display: inline-flex; margin-right:40px">
                <mdicon name="check-bold" class="checkbox-label-icon" :class="option.defaultOn ? 'checkbox-label-icon-active' : ''" size="15" />
              </label>
            </div>

            <button class="default-form-field-button item" @mousedown="remove(i)" >
              <mdicon name="minus" class="default-form-field-button-icon" size="25" />
            </button>
          </div>

          <button class="default-form-field-button" @click="add(schuifwandOptions.length)">
            <mdicon name="plus" class="default-form-field-button-icon" size="25" />
          </button>
        </div>
      </div>

      <div class="default-form-button">
        <LoadingButton @click="update()" :loading="loading" :disabled="!formValid">Update</LoadingButton>
      </div>

    </form>
  </div>
</template>

<script>
import isEqual from 'lodash.isequal'
import { mapGetters } from 'vuex'
import LoadingButton from '@/components/inputs/buttons/LoadingButton.vue'

export default {
  name: "SchuifwandOptions",

  components: {
    LoadingButton
  },

  data () {
    return {
      schuifwandOptions: [],
      formValid: false,
      loading: false,
      schuifwandOptionsKeyNames: [
        'tochtborstel',
        'meeneemset',
        'slot set',
        'funderingskoker',
        'schuifwand achter shutter'
      ]
    }
  },

  methods: {
    async get () {
      await Promise.all([
        this.$store.dispatch('getSchuifwandOptions'),
        this.$store.dispatch('getTextures'),
      ])
      this.schuifwandOptions = JSON.parse(JSON.stringify(this.data))
    },

    async update () {
      this.loading = true

      let remove = []
      let update = []
      let insert = []

      for (let i = 0; i < this.data.length; i++) {
        const keepId = this.schuifwandOptions.find((t) => t.id === this.data[i].id)
        if (!keepId) {
          // schuifwandType is removed
          remove.push(this.data[i])
        } else {
          const schuifwandTypeChanged = this.schuifwandOptions.find((t) => t.id === this.data[i].id && JSON.stringify(t) !== JSON.stringify(this.data[i]))
          if (schuifwandTypeChanged) {
            // schuifwandType is changed
            update.push(schuifwandTypeChanged)
          }
        }
      }

      for (let i = 0; i < this.schuifwandOptions.length; i++) {
        if (!this.schuifwandOptions[i].id) {
          insert.push(this.schuifwandOptions[i])
        }
      }

      try {
        await this.$store.dispatch('updateSchuifwandOptions', {
          remove: remove,
          update: update,
          insert: insert
        })
      } catch (err) {
        console.log(err)
        this.loading = false
      }

      this.loading = false
      this.schuifwandOptions = JSON.parse(JSON.stringify(this.data))
    },

    add (i) {

      if (i === this.schuifwandOptions.length) {
        this.schuifwandOptions.push({
          id: null,
          keyName: "",
          label: "",
          uiImage: null,
          infobox: null,
          defaultOn: false
        })
      }

      this.$nextTick(() => {
        document.getElementById('input' + (i)).focus()
      })
    },

    remove (i) {
      this.schuifwandOptions.splice(i, 1)
    }
  },

  computed: {
    ...mapGetters({
      data: "getSchuifwandOptions",
      textures: 'getTextures',
      infoboxes: 'getInfoboxes'
    }),

    texturesWithEmpty () {
      return [{ id: null, name: '(leeg)' }, ...this.textures]
    },

    infoboxesWithEmpty () {
      return [{ id: null, name: '(leeg)' }, ...this.infoboxes]
    },

    filteredSchuifwandOptionsKeyNames () {
      return (index) => {
        const currentSelection = this.schuifwandOptions[index]?.keyName;
        return this.schuifwandOptionsKeyNames.filter(keyName => {
          // Include if it's not used by any other option, OR if it's the current selection
          return !this.schuifwandOptions.some((d, i) => d.keyName === keyName && i !== index) || keyName === currentSelection;
        });
      }
    }
  },

  created () {
    this.get()
  },

  watch: {
    schuifwandOptions: {
      deep: true,
      immediate: false,
      handler () {
        if (isEqual(this.schuifwandOptions, this.data)) {
          this.formValid = false
        } else {
          this.formValid = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit {
  display: flex;
  flex-direction: column;
  padding: 25px;
  align-items: center;
  min-width: min(100%, 800px);

  &-form {
    padding: 25px 0px;
    gap: 50px;
    width: 75%
  }
}

.row {
  display: flex;
  flex-wrap: wrap; /* Allow items to wrap if needed */
  width: 100%; /* Adjust as necessary */
  &-header {
    padding-left: 5px;
    justify-content: left !important;
  }
}

.item {
  flex: 1; /* Default flex property for other items */
  width: 0px; // dit werkt op een of andere manier
  box-sizing: border-box; /* Include padding and border in width */
  display: flex;
  align-items: flex-start;
  &:nth-child(1) {
    flex: 0 0 200px;
  }
  // &:nth-child(2) {
  //   flex: 0 0 300px;
  // }
  &:nth-child(3) {
    flex: 0 0 300px;
  }
  &:nth-child(4) {
    flex: 0 0 300px;
  }
  &:nth-child(5) {
    flex: 0 0 120px;
  }
  &:nth-child(6) {
    flex: 0 0 30px;
  }
}

.colors-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.colors-section {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 100%;
}

.colors-header {
  display: flex;
  gap: 10px;
  margin-bottom: 5px;
}

.color-header-item {
  flex: 1;
  // font-size: 12px;
  // font-weight: bold;
  // padding: 5px;
  // text-align: center;
  &:last-child {
    flex: 0 0 30px;
  }
  padding-left: 5px;
  justify-content: left !important;
}

.color-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.color-input {
  flex: 1;
  min-width: 0;
}

.color-delete-btn {
  flex: 0 0 30px;
  height: 30px;
  padding: 2px;
}

.add-color-btn {
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  font-size: 12px;
}

</style>